import { call, put } from 'redux-saga/effects';
import CancelLeaveActions from '../redux/CancelLeaveRedux';
import { api } from './api';


export function* cancelleavesagas(action: any): Generator<any, void, any> {
  const { leave_id } = action;
  const response = yield call(api.cancelLeave, leave_id);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(CancelLeaveActions.cancelLeaveSuccess(response.data));
  } else {
    yield put(CancelLeaveActions.cancelLeaveFailure(response.status));
  }
}